export default __webpack_public_path__ + "static/media/ic_gmx.21784db6.svg";